<template>
  <b-container class="container" fluid>
    <drag-bar></drag-bar>

    <div id="container-iframes">
      <b-container id="game-container" v-show="!showCheckout">
        <!-- <iframe id="game-iframe"> </iframe> -->
      </b-container>

      <checkout-page
        v-show="showCheckout"
        :url="checkoutUrl"
        :widget="checkoutWidget"
        :game="game.gameName"
        @close="closeCheckoutPage()"
      ></checkout-page>
    </div>

    <b-modal
      v-model="showLoginPopup"
      centered
      hide-footer
      hide-header
      no-close-on-esc
      no-close-on-backdrop
    >
      <login-helper @close="showLoginPopup = false" :isPopup="false">
      </login-helper>
    </b-modal>

    <b-modal
      v-model="showFriendsManagement"
      centered
      hide-footer
      hide-header
      fade
      size="lg"
      body-class="p-0 mx-0 pb-3"
      no-close-on-backdrop
      modal-class="friends-management"
    >
      <friends-management @close="showFriendsManagement = false">
      </friends-management>
    </b-modal>

    <b-modal
      v-model="showSettings"
      centered
      hide-backdrop
      hide-footer
      hide-header
      body-class="p-0"
      size="lg"
      fade
      no-close-on-esc
      no-close-on-backdrop
      ok-only
      modal-class="profile-settings-modal"
    >
      <settings-management @close="showSettings = false" isPopup="true">
      </settings-management>
    </b-modal>
    <b-modal
      v-model="showNotification"
      class="my-modal"
      centered
      hide-backdrop
      hide-footer
      hide-header
      body-class="p-0"
      fade
      :size="maxNtfSize"
      no-close-on-esc
      no-close-on-backdrop
      ok-only
      modal-class="game-notifications"
    >
      <notification
        @close="closeNotification()"
        @maxSize="notificationModalResize($event)"
        isPopup="true"
      ></notification>
    </b-modal>

    <b-modal
      v-model="showSupport"
      centered
      hide-backdrop
      hide-footer
      hide-header
      body-class="p-0"
      size="lg"
      fade
      no-close-on-esc
      no-close-on-backdrop
      ok-only
      modal-class="support-modal"
    >
      <support-page
        v-show="showSupport"
        @close="closeSupportPage()"
      ></support-page>
    </b-modal>

    <b-modal
      v-model="showBanner"
      hide-footer
      hide-header
      size="lg"
      centered
      body-class="p-0"
      fade
    >
      <div v-html="bannerCode" class="bannerContainer"></div>
    </b-modal>
  </b-container>
</template>

<script>
import FriendsManagement from "../../components/FriendsManagement";
import SettingsManagement from "../../components/SettingsManagement";
import CheckoutPage from "../../components/CheckoutPage";
import SupportPage from "../../components/Support";
import LoginHelper from "../../components/LoginHelper";
import Notification from "../../components/Notification.vue";
import postscribe from "postscribe";
import Config from "../../config/index";
import DragBar from "../../components/DragBar.vue";
import Network from "../../core/socket/Network";
import EventBus from "../../core/EventBus";
import Revive from "../../core/banner/revive";
import Api from "../../core/Api";
import { Gamedock } from "../../core/tracking/Gamedock";
import { Tracker } from "../../core/tracking/Tracker";
import {
  appendObjectAsQueryParam,
  initFacebookSdk,
  isProduction
} from "../../core/utils";
// import { testBanner } from "../../core/utils/index";

export default {
  name: "Game",
  components: {
    CheckoutPage,
    LoginHelper,
    DragBar,
    FriendsManagement,
    SettingsManagement,
    SupportPage,
    Notification
  },
  data() {
    return {
      EventBus: null,
      SDK: null,
      game: null,
      domain: "plinga.com",
      showCheckout: false,
      showLoginPopup: false,
      showFriendsManagement: false,
      showSettings: false,
      showBanner: false,
      showSupport: false,
      showNotification: false,
      checkoutUrl: null,
      checkoutWidget: {
        width: 700,
        height: 550
      },
      gameContainer: "game-container",
      maxNtfSize: "md",
      bannerCode: ""
      // bannerCode: testBanner
    };
  },
  methods: {
    closeNotification() {
      this.showNotification = false;
      this.maxNtfSize = "md";
    },
    loadGame(args) {
      const url = `${args.url ? args.url : this.game.gameUrl}`;
      this.prepareRpc(this.gameContainer, appendObjectAsQueryParam(url, args));

      this.fitGameIframeToScreen();

      new Gamedock().gamePlay(
        this.game.gdGameId,
        this.game.gameName,
        this.$store.getters.getUser.is_guest
      );

      if (!this.$store.getters.getUser.is_guest) new Tracker().gamePlay();
    },
    prepareRpc(containerId, url) {
      this.SDK._prepareRpc(containerId, url);
    },
    allowFullScreen() {
      const gameIframe = document.querySelector("#game-container iframe");
      gameIframe.setAttribute("allowfullscreen", "");
      gameIframe.setAttribute("webkitallowfullscreen", "");
      gameIframe.setAttribute("mozallowfullscreen", "");
    },
    toggleFullScreen() {
      const gameIframe = document.querySelector("#container-iframes");
      if (document.fullscreenEnabled) {
        console.warn("Fullscreen is enabled!");
        if (!document.fullscreenElement) {
          gameIframe
            .requestFullscreen({ navigationUI: "hide" })
            .then(() => {})
            .catch(err => {
              alert(
                `Error attempting to enable full-screen mode: ${err.message} (${err.name})`
              );
            });
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          }
        }
      } else {
        console.warn(
          "Fullscreen is not available! Allowfullscreen attribute must be set for all <iframe> elements of the document in order to enable fullscreen."
        );
      }
    },
    reloadGame() {
      this.$router.go(0);
    },
    adjustGameHeight(height) {
      const gameIframe = document.querySelector("#game-container iframe");
      gameIframe.style.height = `${height}px`;
    },
    fitGameIframeToScreen() {
      const gameIframe = document.querySelector(
        `#${this.gameContainer} iframe`
      );
      gameIframe.style.width = "100%";
      gameIframe.style.height = "100%";
    },
    subscribeEvents() {
      this.EventBus = new EventBus();
      this.EventBus.subscribe("GAME_LOAD", this.loadGame);
      this.EventBus.subscribe("GAME_PAYMENT_REQUEST", this.openCheckoutPage);
      this.EventBus.subscribe("GAME_ALLOW_FULLSCREEN", this.allowFullScreen);
      this.EventBus.subscribe("GAME_TOGGLE_FULLSCREEN", this.toggleFullScreen);
      this.EventBus.subscribe("GAME_RELOAD", this.reloadGame);
      this.EventBus.subscribe("GAME_ADJUST_HEIGHT", this.adjustGameHeight);
      this.EventBus.subscribe(
        "GAME_FRIENDS_MANAGEMENT",
        this.openFriendsManagement
      );
      this.EventBus.subscribe(
        "GAME_SETTINGS_MANAGEMENT",
        this.openSettingsManagement
      );
      this.EventBus.subscribe("GAME_NOTIFICATIONS", this.openNotification);
      this.EventBus.subscribe("USER_SUPPORT_REQUEST", this.openSupportPage);
      this.EventBus.subscribe("USER_LOGIN_PROMPT", this.openLoginPrompt);
      this.EventBus.subscribe("USER_POST_FACEBOOK", this.postFacebook);
      this.EventBus.subscribe("SHOW_BANNER", data => {
        this.openBanner(data.code);
      });

      window.addEventListener("resize", this.fitGameIframeToScreen);
    },
    openCheckoutPage(checkoutUrl) {
      this.checkoutUrl = checkoutUrl;
      this.checkoutWidget = {
        height:
          this.game.paymentWall.paymentWallWidgetHeight !== undefined
            ? this.game.paymentWall.paymentWallWidgetHeight
            : 550,
        width:
          this.game.paymentWall.paymentWallWidgetWidth !== undefined
            ? this.game.paymentWall.paymentWallWidgetWidth
            : 700
      };

      this.showCheckout = true;
    },
    closeCheckoutPage() {
      this.showCheckout = false;
      this.checkoutUrl = null;
    },
    openSupportPage() {
      this.showSupport = true;
    },
    closeSupportPage() {
      this.showSupport = false;
    },
    openLoginPrompt() {
      this.showLoginPopup = true;
    },
    openFriendsManagement() {
      this.showFriendsManagement = true;
    },
    openSettingsManagement() {
      this.showSettings = true;
    },
    openNotification() {
      this.showNotification = true;
    },
    openShop(vcurrency) {
      this.closeBanner();
      if (this.game.usingFlexibleShop)
        this.EventBus.broadcast("GAME_INGAME_SHOP");
      else this.EventBus.broadcast("GAME_STANDARD_SHOP", vcurrency);
    },
    openBanner(code) {
      if (code) {
        this.showBanner = true;
        this.bannerCode = code;
      }
    },
    closeBanner() {
      this.showBanner = false;
      this.bannerCode = "";
    },
    postFacebook(bundleData) {
      /**
       bundleData contains
       title : text, which is shown as title 
       body: text of the post 
       pic : link to a picture, which is shown in the post 
       link : link to the game (deprecated, as we automatically link the posts to the game)
       linktext: text to display for the link ("Play it now") 
     */
      const vm = this;
      initFacebookSdk(vm.$store.getters.getLocale).then(() => {
        // eslint-disable-next-line no-undef
        FB.ui({
          method: "share",
          title: bundleData.title,
          href: bundleData.link
            ? bundleData.link
            : bundleData.pic
            ? bundleData.pic
            : window.location.href,
          message: bundleData.linktext,
          description: bundleData.body
        });
      });
    },
    notificationModalResize(event) {
      if (event === "lg") {
        let element = document.querySelectorAll(
          ".game-notifications.modal .modal-dialog"
        );
        element[0].style.maxWidth = "735px";
      }
    },
    gameNotificationTotalUnseen() {
      this.$store.dispatch("gameNotificationTotalUnseen").then(response => {
        this.$store.commit("NOTIFICATION_TOTAL", response);
      });
    }
  },
  created() {},
  destroyed() {},
  beforeRouteLeave(to, from, next) {
    next();
  },
  beforeMount() {
    this.game = this.$store.getters.getGame;
    this.gameNotificationTotalUnseen();
  },
  async mounted() {
    const vm = this;
    vm.subscribeEvents();

    // If the user is not a guest, then we need friend list
    // We do this here because, the user may have different friends for each game
    if (!vm.$store.getters.getUser.is_guest)
      await vm.$store.dispatch("fetchFriends");

    // Connect network
    vm.Network = new Network({
      uid: vm.$store.getters.getUser.uid,
      game: { gameName: vm.game.gameName, gdGameId: vm.game.gdGameId },
      token: vm.$store.getters.getToken
    });

    // Check banners
    const revive = new Revive({
      domain: vm.$store.getters.getDomain,
      gameName: vm.game.gameName,
      language: vm.$store.getters.getLocale,
      platform: vm.game.platform,
      uid: vm.$store.getters.getUser.uid
    });
    revive.loadBanners();

    // Define window global functions so that banner code can access
    window.gdplay = {
      closeBanner: this.closeBanner,
      openShop: this.openShop
    };

    // Initiate SDK
    //eslint-disable-next-line
    postscribe('#game-container', `<script src="${Config.SDK_URL}"><\/script>`, {
        done: () => {
          Api.sessionateGameUser({
            game: vm.game.gameName,
            uid: vm.$store.getters.getUser.uid,
            platform: vm.game.platform
          })
            .then(response => {
              if (response.success) {
                const SDK = window.GD_Plus_SDK;
                vm.SDK = new SDK({
                  user: vm.$store.getters.getUser,
                  game: vm.game,
                  config: {
                    platform: vm.game.platform,
                    domain: vm.$store.getters.getDomain,
                    isProduction: isProduction,
                    language: vm.$store.getters.getLocale,
                    locale: vm.$store.getters.getLocale,
                    session: response.data,
                    paymentUrl: Config.PAYMENT_API_URL
                  }
                });
                vm.SDK._init();

                if (vm.$store.getters.getUser.is_guest) {
                  vm.showLoginPopup = true;
                }
              } else {
                this.EventBus.broadcast("NOTIFICATION", {
                  success: false,
                  message: response.error
                });
              }
            })
            .catch(err => {
              this.EventBus.broadcast("NOTIFICATION", {
                success: false,
                message: err.message
              });
            });
        }
      }
    );
  }
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 100%;
  height: 100%;
  padding: 0;
}

#container-iframes {
  max-width: 100%;
  height: 100%;
  padding: 0;
}

.s-bar {
  width: 100%;
  height: 70px;
}

#game-container {
  width: 100%;
  /* height: calc(100% - 70px); */
  height: 100%;
  text-align: center;
}

checkout-page {
  width: 100%;
  /* height: calc(100% - 70px) !important; */
  text-align: center;
  display: flex;
}

.bannerContainer {
  --primary: #e05d26;
  --grey: #454545;
  --lightgrey: #666;
  color: var(--grey);
  line-height: 1.55;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: stretch;
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  height: 300px !important;
}
</style>
